import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
    PreloadAllModules,
    provideRouter,
    withPreloading,
    withRouterConfig,
    withViewTransitions,
} from "@angular/router";
import { provideNgxMask } from "ngx-mask";
import { routes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { errorInterceptor } from "./core/interceptors/error.interceptor";
import { MaterialModule } from "./material";

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
        provideRouter(
            routes,
            withPreloading(PreloadAllModules),
            withViewTransitions(),
            withRouterConfig({
                paramsInheritanceStrategy: "always",
            }),
        ),
        importProvidersFrom(MaterialModule),
        provideAnimations(),
        provideNgxMask(),
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: { usePopover: false },
        },
    ],
};
